module.exports = __webpack_public_path__ + "media/application/images/ui/logo-no-strap-47bda837069965c93c17e0c97bf68fc5.png";